import { FeedbackTone } from "../../types/admin";

type AuthFlowNoticeProps = {
  backToSignInLabel: string;
  message: string;
  onBackToSignIn: () => void;
  showBackToSignIn: boolean;
  tone: FeedbackTone;
};

export const AuthFlowNotice = ({
  backToSignInLabel,
  message,
  onBackToSignIn,
  showBackToSignIn,
  tone,
}: AuthFlowNoticeProps) => {
  return (
    <div className={`flow-notice is-${tone}`}>
      <p className="flow-notice-message">{message}</p>
      {showBackToSignIn ? (
        <button
          className="link-button inline-link"
          onClick={onBackToSignIn}
          type="button"
        >
          {backToSignInLabel}
        </button>
      ) : null}
    </div>
  );
};
